var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);
dependencies["front/components/IntroText/IntroText.jinja"] = require( "front/components/IntroText/IntroText.jinja" );
dependencies["front/components/FeatureList/FeatureList.jinja"] = require( "front/components/FeatureList/FeatureList.jinja" );
dependencies["front/components/PersonList/PersonList.jinja"] = require( "front/components/PersonList/PersonList.jinja" );
dependencies["front/components/LogoItem/LogoItem.jinja"] = require( "front/components/LogoItem/LogoItem.jinja" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["About.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/components/IntroText/IntroText.jinja", false, "About.jinja", function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("IntroText", t_1);
env.getTemplate("front/components/FeatureList/FeatureList.jinja", false, "About.jinja", function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("FeatureList", t_4);
env.getTemplate("front/components/PersonList/PersonList.jinja", false, "About.jinja", function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("PersonList", t_7);
env.getTemplate("front/components/LogoItem/LogoItem.jinja", false, "About.jinja", function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
t_10.getExported(function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
context.setVariable("LogoItem", t_10);
output += "<div class=\"About\">\n    ";
output += runtime.suppressValue((lineno = 6, colno = 29, runtime.callWrap(runtime.memberLookup((t_1),"IntroText"), "IntroText[\"IntroText\"]", context, [runtime.contextOrFrameLookup(context, frame, "about"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_13 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_14 = "";;
frame = frame.pop();
return new runtime.SafeString(t_14);
});
return macro_t_13;})()})])), env.opts.autoescape);
output += "\n\n    <div class=\"u-CommonButtonWrapper About-buttonWrapper\">\n        <button class=\"About-button u-CommonButton\">";
output += runtime.suppressValue((lineno = 9, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Заказать проект"])), env.opts.autoescape);
output += "</button>\n    </div>\n\n    ";
output += runtime.suppressValue((lineno = 12, colno = 33, runtime.callWrap(runtime.memberLookup((t_4),"FeatureList"), "FeatureList[\"FeatureLis\"]", context, [runtime.contextOrFrameLookup(context, frame, "features"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_15 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_16 = "";;
frame = frame.pop();
return new runtime.SafeString(t_16);
});
return macro_t_15;})()})])), env.opts.autoescape);
output += "\n\n    <ul class=\"About-personList\">\n        ";
output += runtime.suppressValue((lineno = 15, colno = 35, runtime.callWrap(runtime.memberLookup((t_7),"PersonList"), "PersonList[\"PersonList\"]", context, [runtime.contextOrFrameLookup(context, frame, "persons"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"is_tablet"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_17 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_18 = "";;
frame = frame.pop();
return new runtime.SafeString(t_18);
});
return macro_t_17;})()})])), env.opts.autoescape);
output += "\n    </ul>\n\n    <ul class=\"About-logoList\">\n        ";
frame = frame.push();
var t_21 = runtime.contextOrFrameLookup(context, frame, "logos");
if(t_21) {var t_20 = t_21.length;
for(var t_19=0; t_19 < t_21.length; t_19++) {
var t_22 = t_21[t_19];
frame.set("l", t_22);
frame.set("loop.index", t_19 + 1);
frame.set("loop.index0", t_19);
frame.set("loop.revindex", t_20 - t_19);
frame.set("loop.revindex0", t_20 - t_19 - 1);
frame.set("loop.first", t_19 === 0);
frame.set("loop.last", t_19 === t_20 - 1);
frame.set("loop.length", t_20);
output += "\n            ";
output += runtime.suppressValue((lineno = 20, colno = 35, runtime.callWrap(runtime.memberLookup((t_10),"LogoItem"), "LogoItem[\"LogoItem\"]", context, [t_22,runtime.makeKeywordArgs({"caller": (function (){var macro_t_23 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_24 = "";;
frame = frame.pop();
return new runtime.SafeString(t_24);
});
return macro_t_23;})()})])), env.opts.autoescape);
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") % 3 == 0 && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"last")) {
output += "\n                <div class=\"About-divider\"></div>\n            ";
;
}
output += "\n        ";
;
}
}
frame = frame.pop();
output += "\n    </ul>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["About.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/About/About.jinja
// module id = 98
// module chunks = 0